(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calvielle-contact-studio"] && !Shopify.designMode) return;
  try {
    
  function bindContactStudio(){
    document.querySelectorAll('.cv-contact__form').forEach(form=>{
      if(form.dataset.bound)return;
      form.dataset.bound='true';
      const message=form.querySelector('[data-contact-message]'),error=form.querySelector('[data-contact-error]');
      const validate=show=>{const valid=Array.from(message.value.trim()).length>=5;message.setCustomValidity(valid?'':message.dataset.errorText);if(show||valid){error.textContent=valid?'':message.dataset.errorText;message.setAttribute('aria-invalid',String(!valid));}return valid;};
      message.addEventListener('input',()=>validate(false));message.addEventListener('blur',()=>validate(true));message.addEventListener('invalid',()=>validate(true));
      form.addEventListener('submit',event=>{if(!validate(true)){event.preventDefault();message.reportValidity();}});validate(false);
    });
  }
  bindContactStudio();document.addEventListener('shopify:section:load',bindContactStudio);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calvielle-faq"] && !Shopify.designMode) return;
  try {
    
  function bindCalvielleFaq(){
    document.querySelectorAll('.calvielle-faq__item').forEach(item=>{
      if(item.dataset.faqMotion)return;
      const summary=item.querySelector('summary'),answer=item.querySelector('.calvielle-faq__answer');
      if(!summary||!answer)return;
      item.dataset.faqMotion='true';
      let expanded=item.open,animation=null,fade=null;
      const sync=()=>{item.dataset.faqExpanded=String(expanded);summary.setAttribute('aria-expanded',String(expanded));answer.inert=!expanded;answer.setAttribute('aria-hidden',String(!expanded));};
      const settle=()=>{animation?.cancel();fade?.cancel();animation=null;fade=null;item.open=expanded;item.style.removeProperty('height');item.style.removeProperty('overflow');sync();};
      sync();
      summary.addEventListener('click',event=>{
        event.preventDefault();
        const height=item.getBoundingClientRect().height,opacity=expanded?getComputedStyle(answer).opacity:'0';
        animation?.cancel();fade?.cancel();
        expanded=!expanded;sync();
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){settle();return;}
        item.open=true;item.style.height='auto';item.style.overflow='hidden';
        const border=parseFloat(getComputedStyle(item).borderBottomWidth)||0;
        const target=expanded?item.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
        item.style.height=height+'px';
        animation=item.animate({height:[height+'px',target+'px']},{duration:420,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
        fade=answer.animate({opacity:[opacity,expanded?'1':'0']},{duration:280,easing:'ease',fill:'forwards'});
        animation.onfinish=settle;
      });
      item.addEventListener('toggle',()=>{if(!animation){expanded=item.open;sync();}});
      const resize=new ResizeObserver(()=>{if(animation)settle();});resize.observe(summary);
      item.addEventListener('focusout',()=>{if(!expanded&&answer.contains(document.activeElement))summary.focus();});
    });
  }
  bindCalvielleFaq();document.addEventListener('shopify:section:load',bindCalvielleFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
